// Modules
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils
import { emailIsValidFormat } from './utils/emailValidation';
import {
  getPhoneDigitsOnly,
  phoneIsValidFormat,
} from './utils/phoneValidation';

// Styles
import styles from './ReceiptButtons.module.scss';

function inputIsValid(type, value) {
  switch (type) {
    case 'email':
      return emailIsValidFormat(value);

    case 'text_message':
      return phoneIsValidFormat(value);

    case 'no_thanks':
      return true;

    default:
      return false;
  }
}

const ReceiptButtons = (props) => {
  const {
    email = '',
    phone = '',
    cardType = '',
    lastFourDigits = '',
    defaultSelected = 'text_message',
    callback,
  } = props;

  const [selected, setSelected] = useState(defaultSelected);
  const [input, setInput] = useState(setInputByReceiptType(defaultSelected));
  const [isValidInput, setIsValidInput] = useState(true);

  function setInputByReceiptType(receiptType) {
    switch (receiptType) {
      case 'email':
        return email;

      case 'text_message':
        return phone;

      case 'no_thanks':
        return '';

      default:
        return '';
    }
  }

  const handleClick = (receiptType) => {
    setSelected(receiptType);

    const value = setInputByReceiptType(receiptType);

    setInput(value);
  };

  const handleSubmit = () => {
    // Prevent user from clicking button again
    setIsValidInput(false);

    const data = { type: selected, value: input };

    // Send receipt info to parent component
    callback(data);
  };

  const setInputValue = (val, type) => {
    if (type === 'text_message') {
      setInput(`+1${getPhoneDigitsOnly(val)}`);
    } else {
      setInput(val);
    }
  };

  useEffect(() => {
    const valid = inputIsValid(selected, input);
    setIsValidInput(valid);
  }, [selected, input]);

  return (
    <section>
      <hr />

      {cardType && lastFourDigits && (
        <p className={styles.prompt}>
          Your <strong>{cardType}</strong> card ending in{' '}
          <strong>{lastFourDigits}</strong> has been saved successfully
        </p>
      )}

      <p className={styles.prompt}>I'd like my receipt via</p>

      <div className={styles.btnContainer}>
        <button
          data-messagedots='true' // see note in sass file if confused
          className={
            selected === 'text_message'
              ? [styles.btn, styles.selected].join(' ')
              : styles.btn
          }
          onClick={() => handleClick('text_message')}
        >
          <FontAwesomeIcon icon={'comment-alt'} />
          <span>Text Msg</span>
        </button>

        <button
          className={
            selected === 'email'
              ? [styles.btn, styles.selected].join(' ')
              : styles.btn
          }
          onClick={() => handleClick('email')}
        >
          <FontAwesomeIcon icon={'envelope'} />
          <span>Email</span>
        </button>

        <button
          className={
            selected === 'no_thanks'
              ? [styles.btn, styles.selected].join(' ')
              : styles.btn
          }
          onClick={() => handleClick('no_thanks')}
        >
          <FontAwesomeIcon icon={'ban'} />
          <span>No Receipt</span>
        </button>
      </div>

      <div
        className={styles.miniForm}
        style={selected === 'no_thanks' ? { justifyContent: 'flex-end' } : {}}
      >
        {selected === 'no_thanks' ? null : (
          <label aria-label='send receipt to'>
            <input
              type='email'
              value={input}
              onChange={(e) => setInputValue(e.target.value, selected)}
              className={styles.input}
              placeholder={
                selected === 'email'
                  ? 'email@address.com'
                  : selected === 'text_message'
                  ? '(xxx) xxx-xxxx'
                  : ''
              }
            />
          </label>
        )}

        <button
          className={styles.send}
          disabled={!isValidInput}
          onClick={handleSubmit}
        >
          {selected === 'no_thanks' ? 'Done' : 'Send'}
        </button>
      </div>
    </section>
  );
};

export default ReceiptButtons;
